// src/components/Loader.jsx
import React from "react";
import "./Loader.css"; 

const Loader = () => {
  return (
    <>
     {/* <div className="global-loader">
       <div className="spinner"></div>
     </div> */}

      <div className="preloader ">
         <button className="th-btn style3 preloaderCls">Cancel Preloader </button>
         <div className="preloader-inner">
             <span className="loader"></span>
         </div>
     </div>
     
</>
  );
};

export default Loader;
